import React, { useEffect, useState } from "react";
import axios from "axios";
import PercentChange from "./PercentChange";
import TableFilters from "./TableFilters";
import { Activity, Coins, Globe, PieChart } from "lucide-react";

const HeaderInfos = ({ searchTerm, setSearchTerm, viewMode, setViewMode }) => {
  const [headerData, setHeaderData] = useState({
    active_cryptocurrencies: 10420,
    markets: 1240,
    market_cap_change_percentage_24h_usd: 1.45,
    market_cap_percentage: { btc: 48.2, eth: 17.6 },
  });

  useEffect(() => {
    axios
      .get("https://api.coingecko.com/api/v3/global")
      .then((res) => {
        if (res.data && res.data.data) {
          setHeaderData(res.data.data);
        }
      })
      .catch((err) => {
        console.warn("CoinGecko global API error, using default market metrics:", err);
      });
  }, []);

  const btcPercent = headerData.market_cap_percentage?.btc
    ? headerData.market_cap_percentage.btc.toFixed(1)
    : "48.2";
  const ethPercent = headerData.market_cap_percentage?.eth
    ? headerData.market_cap_percentage.eth.toFixed(1)
    : "17.6";

  return (
    <div className="header-container">
      <div className="brand-hero">
        <div className="logo-wrapper">
          <div className="logo-icon-bg">
            <Coins className="brand-logo-icon" size={28} />
          </div>
          <div className="brand-titles">
            <h1>Watch Tower</h1>
            <span className="brand-subtitle">Crypto Market Intelligence</span>
          </div>
        </div>

        <div className="stats-badges">
          <div className="stat-badge">
            <Globe size={14} />
            <span>Cryptos:</span>
            <strong>
              {headerData.active_cryptocurrencies
                ? headerData.active_cryptocurrencies.toLocaleString()
                : "10,400+"}
            </strong>
          </div>
          <div className="stat-badge">
            <Activity size={14} />
            <span>Markets:</span>
            <strong>{headerData.markets ? headerData.markets.toLocaleString() : "1,200+"}</strong>
          </div>
        </div>
      </div>

      <div className="market-metrics-bar">
        <div className="metric-card">
          <span className="metric-label">24h Market Cap Change</span>
          <div className="metric-value">
            <PercentChange percent={headerData.market_cap_change_percentage_24h_usd} />
          </div>
        </div>

        <div className="metric-card">
          <span className="metric-label">BTC Dominance</span>
          <div className="metric-value dominance">
            <PieChart size={14} className="btc-icon" />
            <strong>{btcPercent}%</strong>
          </div>
        </div>

        <div className="metric-card">
          <span className="metric-label">ETH Dominance</span>
          <div className="metric-value dominance">
            <PieChart size={14} className="eth-icon" />
            <strong>{ethPercent}%</strong>
          </div>
        </div>

        <div className="metric-card live-status">
          <span className="metric-label">Network Status</span>
          <div className="status-indicator">
            <span className="dot pulse"></span>
            <strong>Live / Synced</strong>
          </div>
        </div>
      </div>

      <TableFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
    </div>
  );
};

export default HeaderInfos;
